export const DASHBOARD_PATH = '/';
export const LOGIN_PATH = '/login';
export const USERS_PATH = '/users';
export const DEVICES_PATH = '/devices';
export const ACTIVITY_LOG_PATH = '/activityLog';
export const CREATE_ORG_PATH = '/createOrg';
export const SETTINGS_PATH = '/settings';
export const MOBILE_HOME_PATH = '/mobileHome';
export const DEVICE_LOGIN_PATH = '/deviceLogin';
export const USER_RESTRICTED_PERMISSION_PATH = '/userRestriction';
